import { render, staticRenderFns } from "./header-menus-item.vue?vue&type=template&id=81d5fa66&scoped=true&"
import script from "./header-menus-item.vue?vue&type=script&lang=js&"
export * from "./header-menus-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d5fa66",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CMenuItem: require('@chakra-ui/vue').CMenuItem})
